// extracted by mini-css-extract-plugin
module.exports = {"textApply":"styles_textApply__5w4ZY"};